module.exports = __webpack_public_path__ + "img/selected2-min.17a09ed8.png";